import type { Money } from "./model"

/**
 * Formats a minor-units amount as currency. Currency codes arrive lowercase
 * from the backend (Stripe's convention); they are uppercased here for
 * consistency with ISO 4217, not because Intl requires it. Pass the active
 * i18n language so es_MX and en format consistently with the UI.
 */
export default function formatMoney(money: Money, locale?: string): string {
  return new Intl.NumberFormat(locale, {
    style: "currency",
    currency: money.currency.toUpperCase(),
  }).format(money.amount / 100)
}
